import * as React from "react";
const SvgMenu01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 16.965a1.035 1.035 0 0 1 0 2.07H3a1.035 1.035 0 0 1 0-2.07zm0-6a1.035 1.035 0 0 1 0 2.07H3a1.035 1.035 0 0 1 0-2.07zm0-6a1.035 1.035 0 0 1 0 2.07H3a1.035 1.035 0 0 1 0-2.07z"
}));
export default SvgMenu01;
//# sourceMappingURL=Menu01.js.map